import React from "react";
import styled from "styled-components";


type PublicFormContainerProps = {
    className?: string;
    children: React.ReactNode;
};

const PublicFormContainer = ({
    className,
    children,
}: PublicFormContainerProps): JSX.Element => {
    return (
        <Container className={className}>
            {children}
        </Container>
    );
};

const Container = styled.div`
    width: 344px;
`;


export default PublicFormContainer;
